import { render, staticRenderFns } from "./NominationStateComponent.vue?vue&type=template&id=e56a03ec&"
import script from "./NominationStateComponent.vue?vue&type=script&lang=js&"
export * from "./NominationStateComponent.vue?vue&type=script&lang=js&"
import style0 from "./NominationStateComponent.vue?vue&type=style&index=0&id=e56a03ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports